var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.defaultHeader)?_c('div',[_c('site-header')],1):_vm._e(),(_vm.showLoading)?_c('loader'):_vm._e(),_c('router-view'),(_vm.defaultFooter)?_c('div',[_c('site-footer')],1):_vm._e(),_c('location-permission'),_c('leads-storage'),_c('notifications'),_c('find-plan')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }